import { skipToken } from "@tanstack/react-query";
import { workspaceRouter } from "@trpc/workspace";
import { useCurrentWorkspace } from "@v2/contexts/WorkspaceDashboardContext";

const useChatMessagesUsage = () => {
  const workspace = useCurrentWorkspace();

  const { data: chatMessagesUsage } =
    workspaceRouter.getChatMessagesUsage.useQuery(
      !workspace?.id ? skipToken : workspace.id,
      {
        enabled: workspace?.paymentProcessor === "stripe",
      },
    );

  return chatMessagesUsage;
};

export default useChatMessagesUsage;
